import { startTransition, useEffect, useState } from 'react';

import RegisterNewsletterPopup from '@/components/popups/RegisterNewsletterPopup';
import { useLocation } from 'react-router-dom';

const NEWSLETTER_SHOWN_KEY = 'newsletter_shown_at';
const NEWSLETTER_SUPPRESS_MS = 5 * 24 * 60 * 60 * 1000; // 5 days

const InviteNewsletterCookie = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [hasTriggered, setHasTriggered] = useState(false);
  const isFuelMatchSection = location.pathname.startsWith('/backoffice');

  const markShown = () => {
    localStorage.setItem(NEWSLETTER_SHOWN_KEY, String(Date.now()));
  };

  useEffect(() => {
    if (isFuelMatchSection || hasTriggered) return;

    const hasConsented = !!localStorage.getItem('rcc_consent');
    if (!hasConsented) return;

    const shownAt = localStorage.getItem(NEWSLETTER_SHOWN_KEY);
    const isRecent = shownAt && Date.now() - Number(shownAt) < NEWSLETTER_SUPPRESS_MS;
    if (isRecent) return;

    const timer = setTimeout(() => {
      startTransition(() => {
        setShowPopup(true);
        setHasTriggered(true);
      });
    }, 3000);
    return () => clearTimeout(timer);
  }, [isFuelMatchSection, hasTriggered, location.pathname]);

  const handleClose = () => {
    setShowPopup(false);
    markShown();
  };

  if (!showPopup || isFuelMatchSection) return null;

  return <RegisterNewsletterPopup handleClose={handleClose} setCookie5Days={markShown} />;
};

export default InviteNewsletterCookie;
